<div class="Padre">
  <banner-app [Fixtop]="''" [retroSelected]="true" [Ppal]="true" [showPromo]="true"></banner-app>

  <app-stepper [activeStep]="0" class="runt-stepper"></app-stepper>

  <div class="runt-container">
    <div class="row me-0">
      <div class="col-sm-6 offset-md-2 offset-lg-0 runt-title">
        <span class="runt-title__complete">Datos registrados en el RUNT</span>
        <div class="runt-title__divided">
          <p class="runt-title__first my-1">Datos Registrados</p>
          <p class="runt-title__second">en el RUNT</p>
        </div>
        <div class="aliniacionTexto img_ppal textoArriba runt-image__container">
          <img class="styleImage img-responsive" src="./assets/img/Asistencia-en-linea_1080x1080.png" loading="lazy"
            alt="seguro de moto precio" />
        </div>
      </div>

      <div class="runt-info col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0 pe-0">
        <div class="alineacion">
          <div class="mb-3">
            <span class="runt-subtitle px-3">Esta es la moto</span>
            <hr class="styleLinea" />
            @for ( item of orderedMotoDataKeys; track $index) {
            <div class="col my-2 mx-3 text-line">
              <strong><span class="info-key">{{ item }}: </span>
                {{ motoData[item] }}</strong>
            </div>
            }
          </div>

          <div class="my-4">
            <span class="runt-subtitle px-3">Y el dueño</span>
            <hr class="styleLinea" />
            @for ( item of orderedOwnerDataKeys; track $index) {
            <div class="col my-2 mx-3 text-line">
              <strong><span class="info-key">{{ item }}: </span>
                {{ ownerData[item] }}</strong>
            </div>
            }
          </div>

          @if (this.datosGenerales?.LeadResponse?.data?.vehicle?.Prenda ===
          'SI') {
          <div>
            <hr class="styleLinea" />
            @if( this.datosGenerales?.LeadResponse?.additionalInfo?.prendario )
            {
            <div class="col my-2 mx-3 text-line">
              <strong><span class="info-key">Entidad: </span>
                {{
                this.datosGenerales?.LeadResponse?.additionalInfo?.prendario
                }}</strong>
            </div>
            } @else {
            <form [formGroup]="formulario">
              <div class="col">
                <input type="select" class="form-control tipoLetra estiloPrincipal" #bancoPrenda
                  formControlName="bancoPrenda" id="bancoPrenda" placeholder="Escriba la entidad bancaria"
                  name="bancoPrenda" style="
                    border-radius: 12px;
                    border: 1px solid
                      var(--Tonos-neutros-Pantone-429-C, #b4b4b5);
                    height: 48px;
                    width: 339px;
                  " [ngClass]="{ valBanco2: valBanco2, valBanco: valBanco }" (focusout)="validateBankSelection()"
                  (ngModelChange)="validateBankSelection()" [ngbTypeahead]="search" #instance="ngbTypeahead" />
                <small *ngIf="isBankInvalid" class="text-danger tipoLetra">Parece que dejaste un campo importante
                  vacío</small>
              </div>
            </form>
            }
          </div>
          }

          <strong>
            <span class="coincideInfo mt-5 mb-2">¿Los datos coinciden con tu información?</span>
          </strong>
        </div>

        <div class="container buttonsContainer">
          <div class="row">
            <div class="col">
              <button class="btn py-2 botonNoCoincide" type="submit" (click)="onDataMismatch()">
                <strong><span class="estiloTextoBoton"> No coinciden</span>
                </strong>
              </button>
            </div>

            <div class="col">
              <!-- {{ this.isButtonDisabled }} -->
              <button [disabled]="isButtonDisabled" [ngClass]="{
                  'btn-disabled': isButtonDisabled,
                  'btn btn-primary py-2 botonContinuar': !isButtonDisabled
                }" type="submit" (click)="onDataConfirm()">
                <strong>
                  <span class="estiloTextoBoton" [ngClass]="{
                      estiloTextoBoton: isButtonDisabled,
                      'estiloTextoBoton btn-enable': !isButtonDisabled
                    }">
                    Sí, continuar
                  </span>
                </strong>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-footer-app class="footer-fixed" />
</div>